import { Flex } from "@chakra-ui/layout";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import ChatBox from "../../../Components/Chat/ChatBox";
import ChatList from "../../../Components/Chat/ChatList";
import Navbar from "Components/Recruiter/Navbar/Navbar";
import StudentNavbar from "Components/Students/Navbar/Navbar";
import { CompanyProfile } from "./CompanyProfile";
import { UserCard } from "Components/UserCard/UserCard";
import { StudentProfileCard } from "./StudentProfile";
import { useWindow } from "hooks/useWindow";

const Chat = ({ type }) => {
  const { id } = useParams();
  const windowSize = useWindow();
  const [mobileView, setMobileView] = useState({
    chatList: true,
    chatBox: false,
    profile: false,
  });
  // console.log(id);
  return (
    <div>
      {type === "student" ? <StudentNavbar /> : <Navbar />}
      <Flex
        border={windowSize > 500 && mobileView.chatList && "1px solid #E4E4E4"}
        marginTop={windowSize > 500 ? "100px" : "65px"}
        marginLeft={"2%"}
        borderRadius={"10px"}
        marginRight={"2%"}
        height={windowSize > 500 && mobileView.chatList ? "85vh" : "90vh"}
      >
        <ChatList
          type={type}
          mobileView={mobileView.chatList}
          setMobileView={setMobileView}
        />
        <ChatBox
          type={type}
          id={id}
          mobileView={mobileView}
          setMobileView={setMobileView}
        />
        {type === "student" && (
          <CompanyProfile
            type={type}
            id={id}
            setMobileView={setMobileView}
            mobileView={mobileView}
          />
        )}
        {type === "recruiter" && (
          <StudentProfileCard
            type={type}
            id={id}
            setMobileView={setMobileView}
            mobileView={mobileView}
          />
        )}
        {/* <CompanyProfile type={type} id={id} /> */}
      </Flex>
    </div>
  );
};

export default Chat;
